/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Body } from '../../Layouts/Body'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { Main } from './styles'
import { Alert, AlertDescription, AlertIcon, AlertTitle, AvatarGroup, Divider, Flex, Radio, RadioGroup, Tab, TabList, TabPanel, TabPanels, Tabs, Text, useToast } from '@chakra-ui/react'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { TimelineFeedback } from '../Timeline'
import { iItemFeedbackResponse, iNomeId, iParticipanteFeedbackResponse, iParticipanteInvalido } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { FindUser } from '../../../components/FindBox'
import { FaCog, FaPlus } from 'react-icons/fa'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import { SelectCmp } from '../../../components/SelectCmp'
import { TabelaParticipante } from './TabelaParticipante'
import { ModalCriarGrupo } from './ModalCriarGrupo'
import { ModalDelete } from '../../../components/ModalDelete'
import { ModalGerenciarGrupos } from './ModalGerenciarGrupos'
import { CheckboxCmp } from '../../../components/CheckboxCmp'
import { TabButton } from './TabButton'
import { CardItem } from './CardItem'
import { ModalItemParticipante } from './ModalItemParticipantes'
import { TabelaParticipantesInvalidos } from './TabelaParticipantesInvalidos'
import LoadingContainer from '../../../components/LoadingContainer'

interface iItensExclusivos {
  itensExclusivos: boolean
  entrada: iItemFeedbackResponse[]
  desenvolvimento: iItemFeedbackResponse[]
}

export const ParticipantesFeedback: React.FC = () => {
  const nav = useNavigate()
  const { id } = useParams()
  const { pathname } = useLocation()
  const toast = useToast()
  const [Participantes, setParticipantes] = useState<iParticipanteFeedbackResponse[]>([])
  const [Tipo, setTipo] = useState(0)
  const [GrupoSelecionado, setGrupoSelecionado] = useState<string>()
  const [ColabSelecionado, setColabSelecionado] = useState<string>()
  const [AreaSelecionada, setAreaSelecionada] = useState<string>()
  const [DeleteParticipanteId, setDeleteParticipanteId] = useState<string>()
  const [CargoSelecionado, setCargoSelecionado] = useState<string>()
  const [SquadSelecionado, setSquadSelecionado] = useState<string>()
  const [ResponsavelSelecionado, setResponsavelSelecionado] = useState<string>()
  const [Colaboradores, setColaboradores] = useState<iNomeId[]>([])
  const [TipoResponsavel, setTipoResponsavel] = useState(0)
  const [ModalCriarGrupoIsOpen, setModalCriarGrupoIsOpen] = useState(false)
  const [ModalGerenciarGrupoIsOpen, setModalGerenciarGrupoIsOpen] = useState(false)
  const [ModelItensExclusivos, setModelItensExclusivos] = useState<iItensExclusivos>({ desenvolvimento: [], entrada: [], itensExclusivos: false })
  const [IsLoadingParticipantes, setIsLoadingParticipantes] = useState(false)
  const [IsLoadingParticipantesCalibracao, setIsLoadingParticipantesCalibracao] = useState(false)
  const [IsLoadingColaboradores, setIsLoadingColaboradores] = useState(false)
  const [IsLoadingItensExclusivos, setIsLoadingItensExclusivos] = useState(false)
  const [FaseItens, setFaseItens] = useState(0)
  const [TipoCalibracao, setTipoCalibracao] = useState<number>()
  const [ItemSelecionado, setItemSelecionado] = useState<iItemFeedbackResponse>()

  const [Cargos, setCargos] = useState<iNomeId[]>([])
  const [Areas, setAreas] = useState<iNomeId[]>([])
  const [Squads, setSquads] = useState<iNomeId[]>([])

  function ObterDepartamentos(): void {
    appApi.get('Departamento/Select')
      .then(res => setAreas(res.data))
      .catch(err => console.log(err))
  }

  function ObterCargos(): void {
    appApi.get('Cargo/Select')
      .then(res => setCargos(res.data))
      .catch(err => console.log(err))
  }

  function ObterSquads(): void {
    appApi.get('Tag/Select?tipo=2')
      .then(res => setSquads(res.data))
      .catch(err => console.log(err))
  }

  function getColaboradores(): void {
    setIsLoadingColaboradores(true)
    appApi.get('Colaborador/Select')
      .then(res => setColaboradores(res.data))
      .catch(err => console.log(err))
      .finally(() => setIsLoadingColaboradores(false))
  }

  function getParticipantes(): void {
    setIsLoadingParticipantes(true)
    appApi.get(`FeedbackPersonalizado/${id}/Participantes`)
      .then((res) => setParticipantes(res.data))
      .catch((err) => console.log(err))
      .finally(() => setIsLoadingParticipantes(false))
  }

  function GetInvalidParticipantes(): iParticipanteInvalido[] {
    const invalidos: iParticipanteInvalido[] = []
    Participantes.forEach(p => {
      p.colaboradoresId.forEach(cid => {
        const colab = Colaboradores.find(c => c.id === cid)
        if (colab && p.tipoResponsavel === 0 && !colab.gestorId) {
          invalidos.push({ colaborador: colab, motivo: 'Gestor não foi encontrado' })
        } else if (colab && p.tipoResponsavel === 1 && !Colaboradores.some(c => c.id === p.responsavelId)) {
          invalidos.push({ colaborador: colab, motivo: 'Responsável pelo colaborador não foi encontrado' })
        }
      })
    })

    return invalidos
  }

  function onUpdateCalibracao(tipo: string): void {
    appApi.patch(`FeedbackPersonalizado/${id}/UpdateCalibracao?tipo=${tipo}`)
      .then(() => {
        setTipoCalibracao(parseInt(tipo))
      })
      .catch((err) => console.log(err))
  }

  function onGetCalibracao(): void {
    appApi.get(`FeedbackPersonalizado/${id}/Calibracao`)
      .then((res) => {
        setTipoCalibracao(res.data)
      })
      .catch((err) => console.log(err))
  }

  function OnPatchStatusParticipantes(pathname: string, status: number): void {
    setIsLoadingParticipantes(true)
    appApi.patch(`FeedbackPersonalizado/${id}/Status?status=${status}`)
      .then(() => nav(pathname))
      .catch(err => console.log(err))
      .finally(() => setIsLoadingParticipantes(false))
  }

  function clearOptions(): void {
    setColabSelecionado(undefined)
    setResponsavelSelecionado(undefined)
    setAreaSelecionada('')
    setCargoSelecionado('')
    setGrupoSelecionado('')
  }

  function onAddParticipante(): void {
    setIsLoadingParticipantes(true)
    appApi.patch(`FeedbackPersonalizado/${id}/Participantes?participanteId=${ColabSelecionado ?? ''}&responsavelId=${ResponsavelSelecionado ?? ''}&tipoParticipante=${Tipo ?? ''}&tipoResponsavel=${TipoResponsavel ?? ''}&areaId=${AreaSelecionada ?? ''}&cargoId=${CargoSelecionado ?? ''}&squadId=${SquadSelecionado ?? ''}&grupoId=${GrupoSelecionado ?? ''}`)
      .then(() => {
        getParticipantes()
        clearOptions()
        toast({
          title: 'Participante adicionado com sucesso',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
        appApi.post(`FeedbackPersonalizado/${id}/GestaoParticipantes/Automatico?faltantes=true`)
          .then(() => {})
          .catch((err) => console.log(err))
      })
      .catch((err) => { console.log(err); setIsLoadingParticipantes(false) })
  }

  function clearAdd(): void {
    setAreaSelecionada('')
    setCargoSelecionado('')
    setSquadSelecionado('')
  }

  function createGrupo(idGrupo: string): void {
    setGrupoSelecionado(idGrupo)
    getParticipantes()
    setModalCriarGrupoIsOpen(false)
  }

  function onExcluirParticipante(participanteId: string): void {
    appApi.delete(`FeedbackPersonalizado/${id}/Participante/${participanteId}`)
      .then(() => {
        getParticipantes()
        toast({
          title: 'Participante excluído com sucesso!',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        setDeleteParticipanteId(undefined)
      })
      .catch((err) => console.log(err))
  }

  function onExcluirGrupo(grupoId: string): void {
    appApi.delete(`FeedbackPersonalizado/${id}/Grupo/${grupoId}`)
      .then(() => {
        getParticipantes()
        toast({
          title: 'Grupo excluído com sucesso!',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
      })
      .catch((err) => console.log(err))
  }

  function onUpdateGrupo(grupoId: string, novoNome: string): void {
    appApi.put(`FeedbackPersonalizado/${id}/Grupo/${grupoId}?novoNome=${novoNome ?? ''}`)
      .then(() => {
        getParticipantes()
        toast({
          title: 'Grupo atualizado com sucesso!',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
      })
      .catch((err) => console.log(err))
  }

  function onChangeItensExclusivos(bool: boolean): void {
    setIsLoadingItensExclusivos(true)
    appApi.patch(`FeedbackPersonalizado/${id}/ItensExclusivos?value=${bool}`)
      .then(() => getItensExclusivos())
      .catch((err) => console.log(err))
  }

  function onUpdateGrupoParticipante(grupoId: string, novoGrupoId: string, participanteId: string): void {
    appApi.put(`FeedbackPersonalizado/${id}/Grupo/${grupoId}/Participante?participanteId=${participanteId ?? ''}&novoGrupoId=${novoGrupoId ?? ''}`)
      .then(() => {
        getParticipantes()
        toast({
          title: 'Participante atualizado com sucesso!',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
      })
      .catch((err) => console.log(err))
  }

  function OnSaveItensOcultos(gruposIds: string[], item: iItemFeedbackResponse): void {
    appApi.put(`FeedbackPersonalizado/${id}/ItensExclusivos/${item.id}`, { ids: gruposIds })
      .then(() => {
        getParticipantes()
        toast({
          title: 'Itens atualizados com sucesso!',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        setItemSelecionado(undefined)
      })
      .catch((err) => console.log(err))
  }

  function getItensExclusivos(): void {
    setIsLoadingItensExclusivos(true)
    appApi.get(`FeedbackPersonalizado/${id}/ItensExclusivos`)
      .then(res => setModelItensExclusivos(res.data))
      .catch(err => console.log(err))
      .finally(() => setIsLoadingItensExclusivos(false))
  }

  useEffect(() => {
    getParticipantes()
    getColaboradores()
    getItensExclusivos()
    ObterDepartamentos()
    ObterCargos()
    ObterSquads()
    onGetCalibracao()
  }, [])

  return (
    <Body isLoading={IsLoadingColaboradores || IsLoadingParticipantes || IsLoadingItensExclusivos || IsLoadingParticipantesCalibracao}>
      {DeleteParticipanteId && <ModalDelete
        isOpen={!!DeleteParticipanteId}
        message={'Tem certeza que deseja remover esse participante?'}
        onConfirm={() => onExcluirParticipante(DeleteParticipanteId)}
        onRequestClose={() => setDeleteParticipanteId(undefined)}
        center
      />}
      <ModalCriarGrupo
        feedbackId={id ?? ''}
        isOpen={ModalCriarGrupoIsOpen}
        onConfirm={createGrupo}
        onRequestClose={() => setModalCriarGrupoIsOpen(false)}
      />
      {ItemSelecionado && <ModalItemParticipante
        colaboradores={Colaboradores}
        item={ItemSelecionado}
        isOpen
        onRequestClose={() => setItemSelecionado(undefined)}
        onSave={(gruposIds) => OnSaveItensOcultos(gruposIds, ItemSelecionado)}
        participantes={Participantes}
      />}
      <ModalGerenciarGrupos
        grupos={Participantes.filter(e => e.nomeGrupo)}
        isOpen={ModalGerenciarGrupoIsOpen}
        onClose={() => setModalGerenciarGrupoIsOpen(false)}
        onDelete={(idGrupo) => onExcluirGrupo(idGrupo)}
        onUpdate={(idGrupo, novoNome) => onUpdateGrupo(idGrupo, novoNome)}
      />
      <TimelineFeedback id={id ?? ''}/>
      <Main>
        <h1>Selecionar participantes</h1>
        <Flex flexDir={'column'} gap={'1.25rem'}>
          <WhiteContainer>
            <Flex flexDir={'column'} gap={'1rem'} mb={'.5rem'}>
              <Flex flexDir={'column'} gap={'.25rem'}>
                <Text fontSize={'16px'} fontWeight={'600'}>Selecione uma das opções para adicionar os participantes</Text>
              </Flex>
              <Flex gap={'1rem'}>
                <TabButton message='Convidar participante único' tipo={0} onChangeTipo={setTipo} tipoAtivo={Tipo}/>
                <TabButton message='Convidar colaboradores de uma área/função/squad' tipo={1} onChangeTipo={setTipo} tipoAtivo={Tipo}/>
                <TabButton message='Convidar todos os colaboradores' tipo={2} onChangeTipo={setTipo} tipoAtivo={Tipo}/>
              </Flex>
                {Tipo === 0 && <Flex flexDir={'column'} gap={'.75rem'} alignItems={'end'}>
                  <Flex flexDir={'column'} gap={'.325rem'} w={'full'}>
                    <Text fontWeight={'500'} fontSize={'.875rem'} color={'var(--Gray1)'}>Nome do colaborador</Text>
                    <FindUser
                      lista={Colaboradores.filter(e => e.id !== ResponsavelSelecionado && !Participantes.some(p => p.colaboradoresId.some(cId => cId === e.id)))}
                      onChoice={setColabSelecionado}
                      selecionado={ColabSelecionado}
                      placeholder='Digite o nome do participante'
                    />
                  </Flex>
                </Flex>}
                {Tipo === 1 && <Flex flexDir={'column'} gap={'.75rem'} w={'full'}>
                  <Tabs variant='unstyled'>
                    <TabList gap={'.5rem'} px={'0'}>
                      <Tab
                        color={'var(--Rosa)'}
                        bg={'white'}
                        py={'.325rem'}
                        px={'.5rem'}
                        fontSize={'.813rem'}
                        border={'2px solid var(--Rosa)'}
                        borderRadius={'0.25rem'}
                        onClick={clearAdd}
                        _selected={{ color: 'white', bg: 'var(--Rosa)' }}
                      >Área</Tab>

                      <Tab
                        color={'var(--Rosa)'}
                        bg={'white'}
                        py={'.325rem'}
                        px={'.5rem'}
                        fontSize={'.813rem'}
                        border={'2px solid var(--Rosa)'}
                        borderRadius={'0.25rem'}
                        onClick={clearAdd}
                        _selected={{ color: 'white', bg: 'var(--Rosa)' }}
                      >Função</Tab>

                      <Tab
                        color={'var(--Rosa)'}
                        bg={'white'}
                        py={'.325rem'}
                        px={'.5rem'}
                        fontSize={'.813rem'}
                        border={'2px solid var(--Rosa)'}
                        borderRadius={'0.25rem'}
                        onClick={clearAdd}
                        _selected={{ color: 'white', bg: 'var(--Rosa)' }}
                      >Squad</Tab>
                    </TabList>
                    <TabPanels px={'0'}>
                      <TabPanel px={'0'} pb={'0'}>
                        <Flex gap={'1rem'}>
                          <SelectCmp value={AreaSelecionada} OnChange={setAreaSelecionada} w={'100%'} title={'Selecione a área que deseja puxar os participantes'}>
                            <option value={''}>Nenhum</option>
                            {Areas.filter(r => r.nome !== '').map((area) => {
                              return (
                                <option key={area.id} value={area.id}>{area.nome}</option>
                              )
                            })}
                          </SelectCmp>
                        </Flex>
                      </TabPanel>
                      <TabPanel px={'0'} pb={'0'}>
                        <Flex gap={'1rem'}>
                          <SelectCmp value={CargoSelecionado} OnChange={setCargoSelecionado} w={'100%'} title={'Selecione a função que deseja puxar os participantes'}>
                            <option value={''}>Nenhum</option>
                            {Cargos.filter(r => r.nome !== '').map((cargo) => {
                              return (
                                <option key={cargo.id} value={cargo.id}>{cargo.nome}</option>
                              )
                            })}
                          </SelectCmp>
                        </Flex>
                      </TabPanel>
                      <TabPanel px={'0'} pb={'0'}>
                        <Flex gap={'1rem'}>
                          <SelectCmp value={SquadSelecionado} OnChange={setSquadSelecionado} w={'100%'} title={'Selecione o squad que deseja puxar os participantes'}>
                            <option value={''}>Nenhum</option>
                            {Squads.filter(r => r.nome !== '').map((squad) => {
                              return (
                                <option key={squad.id} value={squad.id}>{squad.nome}</option>
                              )
                            })}
                          </SelectCmp>
                        </Flex>
                      </TabPanel>
                    </TabPanels>
                  </Tabs>
                </Flex>}
                <Flex flexDir={'column'} gap={'.325rem'} w={'100%'} alignItems={Tipo === 2 ? 'center' : undefined}>
                  <Text fontWeight={'500'} fontSize={'.875rem'} color={'var(--Gray1)'}>Tipo de responsável</Text>
                  <RadioGroup value={TipoResponsavel.toString()} size={'sm'} gap={'1rem'} display={'flex'} onChange={(e) => {
                    if (TipoResponsavel === 1 && e !== '1') {
                      setResponsavelSelecionado(undefined)
                    }
                    setTipoResponsavel(parseInt(e))
                  }}>
                    <Radio value={'0'}>Gestor</Radio>
                    <Radio value={'1'}>Outro</Radio>
                  </RadioGroup>
                </Flex>
                {TipoResponsavel === 1 && <Flex flexDir={'column'} gap={'.325rem'} w={'full'}>
                  <Text fontWeight={'500'} fontSize={'.875rem'} color={'var(--Gray1)'}>Nome do responsável</Text>
                  <FindUser
                    lista={Colaboradores.filter(e => e.id !== ColabSelecionado && (e.rh || Colaboradores.some(c => c.gestorId === e.id)))}
                    onChoice={setResponsavelSelecionado}
                    selecionado={ResponsavelSelecionado}
                    placeholder='Digite o nome do responsável por esse participante'
                  />
                </Flex>}
                {Tipo === 0 && <Flex justifyContent={'space-between'} gap={'.75rem'} alignItems={'end'}>
                  <SelectCmp w={'100%'} OnChange={setGrupoSelecionado} value={GrupoSelecionado} title='Selecionar o grupo no qual o participante será adicionado (opcional)'>
                      <option value={''}>Nenhum</option>
                      {Participantes.filter(e => e.nomeGrupo && e.colaboradoresId.length === 0).map(e => {
                        return <option value={e.id}>{e.nomeGrupo}</option>
                      })}
                  </SelectCmp>
                  <ButtonCmp w={'8rem'} VarColor='Green2' leftIcon={<FaPlus/>} onClick={() => setModalCriarGrupoIsOpen(true)}>Criar grupo</ButtonCmp>
                  <ButtonCmp VarColor='Rosa' onClick={() => setModalGerenciarGrupoIsOpen(true)}><FaCog /></ButtonCmp>
                </Flex>}
                <Flex justifyContent={'center'}>
                  <ElementoTooltipCmp bg={'var(--Red)'} label={(Tipo === 0 && !ColabSelecionado) || (TipoResponsavel === 2 && !ResponsavelSelecionado) ? 'Preencha os campos de participante e responsável para adicionar um participante' : undefined}>
                    <ButtonCmp w={'20rem'} isDisabled={(Tipo === 0 && !ColabSelecionado) || (TipoResponsavel === 2 && !ResponsavelSelecionado) || (Tipo === 1 && (!AreaSelecionada && !CargoSelecionado && !SquadSelecionado))} onClick={onAddParticipante} VarColor='Green2'>Adicionar {Tipo === 2 ? 'todos colaboradores restantes' : ' participante'}</ButtonCmp>
                  </ElementoTooltipCmp>
                </Flex>
                <Divider opacity={'.7'} borderColor={'var(--c6)'} mt={'1rem'} mb={'.325rem'}/>
                <Text fontWeight={'600'}>Participantes adicionados</Text>
                {!IsLoadingParticipantes && <TabelaParticipante
                  colaboradores={Colaboradores}
                  participantes={Participantes}
                  onExcluir={setDeleteParticipanteId}
                  onUpdateGrupo={onUpdateGrupoParticipante}
                />}
                {IsLoadingParticipantes && <LoadingContainer linhas={18} loading></LoadingContainer>}
            </Flex>
            <Flex my={'1rem'} flexDir={'column'} gap={'.75rem'}>
              <CheckboxCmp isChecked={ModelItensExclusivos.itensExclusivos} OnChange={onChangeItensExclusivos}>Personalize os itens do feedback para cada participante ou grupo</CheckboxCmp>
              {ModelItensExclusivos.itensExclusivos && <>
                <Divider opacity={'.7'} borderColor={'var(--c6)'} mt={'1rem'} mb={'.325rem'}/>
                <Flex gap={'1rem'} mb={'.5rem'}>
                  <TabButton message='Informações prévias' onChangeTipo={setFaseItens} tipo={0} tipoAtivo={FaseItens}/>
                  <TabButton message='Itens de condução ​' onChangeTipo={setFaseItens} tipo={1} tipoAtivo={FaseItens}/>
                </Flex>
                {FaseItens === 0 && ModelItensExclusivos.entrada.sort((a, b) => { if (a.ordem && b.ordem) { return a.ordem - b.ordem } else { return 0 } }).map(e => {
                  return <CardItem item={e} onOpenModalParticipantes={() => setItemSelecionado(e)}/>
                })}
                {FaseItens === 1 && ModelItensExclusivos.desenvolvimento.sort((a, b) => { if (a.ordem && b.ordem) { return a.ordem - b.ordem } else { return 0 } }).map(e => {
                  return <CardItem item={e} onOpenModalParticipantes={() => setItemSelecionado(e)}/>
                })}
              </>}
            </Flex>
            {GetInvalidParticipantes().length > 0 && <Flex flexDir={'column'} my={'1rem'} gap={'1rem'}>
              <Divider opacity={'.7'} borderColor={'var(--c6)'} mb={'.5rem'}/>
              <Text fontWeight={'600'}>Participantes inválidos</Text>
              <TabelaParticipantesInvalidos onRender={() => getColaboradores()} participantesInvalidos={GetInvalidParticipantes()}/>
              <Alert borderRadius={'.25rem'} justifyContent='space-between' status='warning' px={'.75rem'} py={'.75rem'}>
                <Flex flexDir={'column'} fontSize={'.75rem'}>
                  <Flex alignItems={'center'}>
                    <AlertIcon color={'#FF9900'} mr={'0.325rem'} h={'1.325rem'}/>
                    <AlertTitle lineHeight={'1.25rem'}>IMPORTANTE: </AlertTitle>
                    <AlertDescription lineHeight={'1.25rem'}>Aos participantes com erro, tente fazer os ajustes necessários de acordo com a coluna de "Motivo" na tabela de participantes inválidos.</AlertDescription>
                  </Flex>
                </Flex>
              </Alert>
            </Flex>}
          </WhiteContainer>
        </Flex>

        <Flex justifyContent={'end'} marginTop='1rem' gap={'.5rem'}>
          <ButtonCmp
            VarColor={'c6'}
            onClick={() => nav(-1)}
          >Voltar</ButtonCmp>
          <ElementoTooltipCmp label={GetInvalidParticipantes().length > 0 ? 'Faça os ajustes necessários no organograma para corrigir os erros de participantes inválidos' : ''} bg={'var(--Red)'}>
            <ButtonCmp
              onClick={() => OnPatchStatusParticipantes(pathname.replace('Participantes', 'Envio'), 4)}
              isDisabled={GetInvalidParticipantes().length > 0}
              VarColor='Green2'
            >Continuar</ButtonCmp>
          </ElementoTooltipCmp>
        </Flex>
      </Main>
    </Body>
  )
}
